import React from 'react';
import { Button, Box, Typography, TextField } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Filter from 'bad-words';
import { profinityWords } from '../../../../util/ProfinityWord';
import { postNotesInformation, resetToast } from '../../../../redux/reducers/coreWindows/Note';
import { ErrorSnackbar, SuccessSnackbar } from '../../../../components/CustomSnackBar';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    position: 'relative',
  },
  title: {
    fontFamily: '"articulat-cf", sans-serif !important',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: 24.84,
    textAlign: 'left',
    color: '#3B4149',
  },
  customInput: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  textField: {
    width: '100%',
  },
  textFieldError: {
    '&&': {
      border: '1px solid red',
    },
  },
  cancelButton: {
    '&&': {
      color: '#01579B',
      border: '1px solid #01579B',
      marginRight: '10px',
      textTransform: 'none',
      '&:hover': {
        color: '#FFF',
        backgroundColor: '#01579B',
        borderRadius: '5px',
      },
    },
  },
  saveButton: {
    '&&': {
      color: '#FFF',
      background: '#0288D1',
      border: '1px solid #0288D1',
      textTransform: 'none',
      '&:hover': {
        color: '#0288D1',
        backgroundColor: '#FFF',
        borderRadius: '5px',
      },
    },
  },
}));

const AddNote = ({ accountId, handleCloseModal, action }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { successMsg, errorMsg } = useSelector(({ note }) => note);

  const validationSchema = Yup.object().shape({
    note: Yup.string().required('Please enter your note'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    const filter = new Filter({ placeHolder: '*' });
    filter.addWords(...profinityWords);
    const filteredNote = filter.clean(data.note);
    const text = filteredNote.replace(/\*/g, '');

    dispatch(
      postNotesInformation({
        accountNumber: accountId,
        notes: text,
        actionPerformed: 'Add',
      }),
    );

    setTimeout(() => {
      dispatch(resetToast());
    }, 4000);

    reset();
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h6" component="h2">
        Add a Note
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.customInput}>
          <TextField
            fullWidth
            multiline
            rows={8}
            placeholder="Type a note..."
            variant="outlined"
            name="note"
            error={!!errors.note}
            inputRef={register}
            helperText={errors.note ? errors.note.message : ''}
          />
        </div>
        <Box display="flex" justifyContent="flex-end">
          <Button
            type="button"
            color="inherit"
            size="medium"
            className={classes.cancelButton}
            onClick={(e) => {
              e.stopPropagation();
              handleCloseModal(action);
            }}
          >
            Cancel
          </Button>
          <Button type="submit" color="inherit" size="medium" className={classes.saveButton}>
            Save
          </Button>
        </Box>
      </form>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default AddNote;
